/* eslint-disable */
import $ from 'jquery';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

/* jshint camelcase:false */
Sys.WebForms.PageRequestManager.getInstance().add_endRequest(bindControls);
/* jshint camelcase:true */

bindControls();

function bindControls() {
  $(document).ready(() => {
    var $links = $('.js-file-download');
    var $panel = $('.js-download-panel');
    var $closeButton = $('.js-close-icon');
    var $hdnFileDownload = $('#hdnFileDownload');

    $links.each(function(index, elem) {
      $(elem).on('click', function(e) {
        e.preventDefault();

        $hdnFileDownload.val($(this).data('file-guid'));

        // $panel.css('top', window.pageYOffset);
        $panel.show();
        disableBodyScroll($panel);
      });
    });

    $closeButton.on('click', function(e) {
      clearAllBodyScrollLocks();
      $panel.hide();
    });
  });
}
